module.exports = __webpack_public_path__ + "img/inland-interisland.8a6a1927.jpg";